import { combineReducers } from 'redux';
import selftest from '../components/selftest/reducers/selftest';
import wheelhouse from '../components/wheelhouse/reducers';
import weatherobs from '../components/weatherobs/reducers';

// Top level reducers
const appReducer = combineReducers({
  selftest,
  wheelhouse,
  weatherobs
});

const rootReducer = (state, action) => {
  // Setting undefined state reinitializes each combined reducers default state.
  if (action.type === 'SET_LOGOUT_FULFILLED') return appReducer(undefined, action);

  return appReducer(state, action);
};

export default rootReducer;